/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Reader_PlayingInputs */

const en_funnel_sq_reader_playing = /** @type {(inputs: Funnel_Sq_Reader_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reading aloud`)
};

const es_funnel_sq_reader_playing = /** @type {(inputs: Funnel_Sq_Reader_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leyendo en voz alta`)
};

/**
* | output |
* | --- |
* | "reading aloud" |
*
* @param {Funnel_Sq_Reader_PlayingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_reader_playing = /** @type {((inputs?: Funnel_Sq_Reader_PlayingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Reader_PlayingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_reader_playing(inputs)
	return en_funnel_sq_reader_playing(inputs)
});